import React, {useMemo} from 'react';
import {ContextManager, NoAuthContextManager, ProductProvider} from 'contexts';
import StandalonePreview3D from 'components/customer/Preview3D/StandalonePreview3D';
import {useGetUserQuery} from 'components/customer/Auth/store/userSlice';
import TrademarkPoweredBy from 'shared/components/TrademarkPoweredBy';
import {useParams, useSearchParams} from 'react-router-dom';
import {isNull} from 'lodash';
import ProductInfo from 'components/customer/Preview3D/components/ProductInfo';

const StandalonePreview3DWrapper = () => {
    const {data: userObject, isError} = useGetUserQuery();

    const [query] = useSearchParams();
    const {slug} = useParams();
    const view = query.get('view');

    const isRaw = !isNull(view) && view.toLowerCase() === 'raw';

    // This implies that if it fails and the userObject was null, it could mean that something went wrong or is not logged in
    const isLogggedIn = useMemo(() => {
        return userObject && !isError;
    }, [isError]);

    const previewContent = () => (
        <ProductProvider>
            <div className="position-fixed vh-100">
                {!isRaw && (
                    <>
                        <div
                            className="position-fixed top-0 start-50 translate-middle-x mt-3 p-2"
                            style={{zIndex: 10000}}>
                            <TrademarkPoweredBy />
                        </div>
                        <ProductInfo />
                    </>
                )}

                <StandalonePreview3D slug={slug} />
            </div>
        </ProductProvider>
    );

    // i created two quite identical components, one handles non-authenticated context, by default it handles the secured one
    if (!isLogggedIn) {
        return <NoAuthContextManager>{previewContent()}</NoAuthContextManager>;
    }

    return <ContextManager>{previewContent()}</ContextManager>;
};

export default StandalonePreview3DWrapper;
